import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationItem } from 'src/app/core/models/notification-item';
import { environment } from 'src/environments/environment';
import { PageResp } from '../models/page/page-response';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  notifications: NotificationItem[] = [];

  lastCallApimDate?: Date;
  lastUpdateBellNotifyDt?: Date;
  updateBellNotifyFlag: boolean = false;

  constructor(
    private http: HttpClient
  ) {}

  setUpdateBellNotifyFlag(flag: boolean): void {
    this.updateBellNotifyFlag = flag;
  }

  setUpdateBellNotifyFlagByLastRequestTime(date: Date): void {
    this.lastCallApimDate = date;
    if (this.lastUpdateBellNotifyDt) {
      if (date.getTime() - this.lastUpdateBellNotifyDt.getTime() < 30 * 1000) {
        return;
      }
    }

    this.lastUpdateBellNotifyDt = date;
    this.updateBellNotifyFlag = true;
  }

  async getBellNotifyByAuto(uuid: string, showType: any, isAuto: boolean): Promise<any> {
    if (!this.updateBellNotifyFlag && isAuto) {
      return;
    }

    this.lastUpdateBellNotifyDt = new Date();
    this.updateBellNotifyFlag = false;
    const req = {
      notifyType: 'Bell',
      uuid: uuid,
      isRead: showType
    };
    if (isAuto) {
      return this.getAllNotifyInformationByAuto(req).toPromise();
    }
    return this.getAllNotifyInformation(req).toPromise();
  }

  getAllNotifyInformationByAuto(req: any): Observable<NotificationItem[]> {
    const url = `${environment.logisticsApiUrl}/notify/getNotifyInformationByAuto`;
    return this.http.post<NotificationItem[]>(url, req);
  }

  getAllNotifyInformation(req: any): Observable<NotificationItem[]> {
    const url = `${environment.logisticsApiUrl}/notify/getNotifyInformation`;
    return this.http.post<NotificationItem[]>(url, req);
  }

  getNotifyInformation(req: any): Observable<PageResp<NotificationItem>> {
    const url = `${environment.logisticsApiUrl}/notify/getNotifyInformationByPage`;
    return this.http.post<PageResp<NotificationItem>>(url, req);
  }

  getNotifyInformationFiles(docIds: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/notify/getNotifyInformationFiles`;
    return this.http.post(url, docIds);
  }

  markRead(req: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/notify/markRead`;
    return this.http.post(url, req);
  }

  exportNotifyInformation(params:any, language:any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/notify/exportNotifyInformation/${language}`;
    return this.http.post(url, params, {responseType : 'blob'});
  }
}
